module.exports = __webpack_public_path__ + "img/img_jiejuefangan.5a33b7f0.png";